angular.module('examgen.directive').
filter('noSectionFilter',function(){
  return function(section){
    if(!section) return;
    //console.log('filtering section',section.sectionName);
    return section.sectionName === '(no section)' ? null : section;
  };
});